/** Codes the backend sends in an error body's `message` that the client branches on. */
export const BackendErrorCode = {
  InvalidRefreshToken: 'invalid_refresh_token',
  SmsGatewayError: 'sms_gateway_error',
  SmtpServerError: 'smtp_server_error',
  MvpMultipleCabinetForbidden: 'MVP_MULTIPLE_CABINET_FORBIDDEN',
  ConfirmationCodeAlreadySent: 'CONFIRMATION_CODE_ALREADY_SENT',
} as const;
export type BackendErrorCode = (typeof BackendErrorCode)[keyof typeof BackendErrorCode];
